// Car catalog — shared by the garage shop and the Toast Town Speedway racer.
// Stats are a triangle: no car is strictly best. Save stores ids only, so
// these numbers can be tuned freely without breaking existing player saves.

export const CARS = [
  { id: 'toastmobile',    name: 'Toastmobile',      icon: '🚗', color: 0xF3E2BE, price: 5,   topSpeed: 22, accel: 10, grip: 0.70, desc: 'the humble starter — balanced but plain' },
  { id: 'bagelbuggy',     name: 'Bagel Buggy',      icon: '🚙', color: 0xD9A441, price: 50,  topSpeed: 25, accel: 11, grip: 0.72, desc: 'zippy all-rounder' },
  { id: 'pretzelpickup',  name: 'Pretzel Pickup',   icon: '🛻', color: 0xA67B5B, price: 90,  topSpeed: 20, accel:  8, grip: 0.95, desc: 'slow but sure-footed, forgiving off-road' },
  { id: 'croissantcruiser', name: 'Croissant Cruiser', icon: '🏎', color: 0xF49B33, price: 150, topSpeed: 30, accel: 12, grip: 0.52, desc: 'fast, slippery handful — top speed wins on the straight' }
];

export function getCarById(id){
  return CARS.find(c => c.id === id) || null;
}
